/**
 * @typedef {Object} CollectionWithMeta
 * @prop {number} lastUpdated
 * @prop {Object[]} items
 */
/**
 * Check to see if a select for a collection should be shown (i.e. for referringProviders & referringLocations)
 * @param {CollectionWithMeta} collectionWithMeta
 * @returns {boolean}
 */
const shouldShowSelectForCollection = collectionWithMeta => {
  const { lastUpdated, items } = collectionWithMeta;
  return lastUpdated && items.length !== 1;
};

export default shouldShowSelectForCollection;
